"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.configurationContextDefaultValues = exports.ConfigurationProvider = exports.ConfigurationContext = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const configurationContextDefaultValues = exports.configurationContextDefaultValues = {
    catalogueCode: '',
    config: {
        downloadEnabled: false,
        fullScreenEnabled: false,
        sharingEnabled: false,
        quickBuyEnabled: false,
        sharingCatalogueEnabled: false,
        sharingPageEnabled: false,
        sharingOfflineCatalogueEnabled: false
    },
    isFlyer: false,
    mainTitle: ''
};
const ConfigurationContext = exports.ConfigurationContext = /*#__PURE__*/ (0, _react.createContext)(configurationContextDefaultValues);
const ConfigurationProvider = (param)=>{
    let { catalogueCode, config, isFlyer, mainTitle, children } = param;
    const value = (0, _react.useMemo)(()=>({
            catalogueCode,
            config,
            isFlyer,
            mainTitle
        }), [
        catalogueCode,
        config,
        isFlyer,
        mainTitle
    ]);
    if (!catalogueCode) {
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConfigurationContext.Provider, {
        value: value,
        children: children
    });
};
exports.ConfigurationProvider = ConfigurationProvider;
